import '../../../src/global.css'
import React from 'react'
import { Box, Button, Typography } from '@material-ui/core'
import { THAIRATH_AUTH_LAUNCH_URL } from '../Login'

/* neutral page after logout, it must never redirect to the launch url by itself */
export default function LoggedOut() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      <Typography variant="h6">You have been logged out</Typography>
      <Box mt={2}>
        <Button
          variant="contained"
          color="primary"
          href={THAIRATH_AUTH_LAUNCH_URL}
        >
          Sign in
        </Button>
      </Box>
    </Box>
  )
}
